'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Publikation = require('../entity').Publikation;

module.exports = function (connection) {
  return {
    byAnyIDValue: function byAnyIDValue(id, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byAnyIDValue', 'id')(id, additionalParams);
    },
    byAnyOrga: function byAnyOrga(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byAnyOrga', 'orgaid')(orgaid, additionalParams);
    },
    byAuthorEquals: function byAuthorEquals(author, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byAuthorEquals', 'author')(author, additionalParams);
    },
    byBandEquals: function byBandEquals(band, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byBandEquals', 'band')(band, additionalParams);
    },
    byBandLike: function byBandLike(band, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byBandLike', 'band')(band, additionalParams);
    },
    byBuchtitelEquals: function byBuchtitelEquals(buchtitel, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byBuchtitelEquals', 'buchtitel')(buchtitel, additionalParams);
    },
    byBuchtitelLike: function byBuchtitelLike(buchtitel, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byBuchtitelLike', 'buchtitel')(buchtitel, additionalParams);
    },
    byForschungsprojektEquals: function byForschungsprojektEquals(forschungsprojekt, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byForschungsprojektEquals', 'forschungsprojekt')(forschungsprojekt, additionalParams);
    },
    byHerausgeberEquals: function byHerausgeberEquals(herausgeber, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byHerausgeberEquals', 'herausgeber')(herausgeber, additionalParams);
    },
    byInProjektEquals: function byInProjektEquals(inprojekt, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byInProjektEquals', 'inprojekt')(inprojekt, additionalParams);
    },
    byInstitutionEquals: function byInstitutionEquals(institution, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byInstitutionEquals', 'institution')(institution, additionalParams);
    },
    byInstitutionLike: function byInstitutionLike(institution, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byInstitutionLike', 'institution')(institution, additionalParams);
    },
    byIstFinalEquals: function byIstFinalEquals(istfinal, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byIstFinalEquals', 'istfinal')(istfinal, additionalParams);
    },
    byJournalEquals: function byJournalEquals(journal, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byJournalEquals', 'journal')(journal, additionalParams);
    },
    byJournalLike: function byJournalLike(journal, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byJournalLike', 'journal')(journal, additionalParams);
    },
    byJournalNummerEquals: function byJournalNummerEquals(journalnummer, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byJournalNummerEquals', 'journalnummer')(journalnummer, additionalParams);
    },
    byJournalNummerLike: function byJournalNummerLike(journalnummer, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byJournalNummerLike', 'journalnummer')(journalnummer, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byPubIdentEquals: function byPubIdentEquals(pubident, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byPubIdentEquals', 'pubident')(pubident, additionalParams);
    },
    byPublikationsTypEquals: function byPublikationsTypEquals(publikationstyp, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byPublikationsTypEquals', 'publikationstyp')(publikationstyp, additionalParams);
    },
    byPubmanID: function byPubmanID(pubmanid, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byPubmanID', 'pubmanid')(pubmanid, additionalParams);
    },
    byRelevantFuerWeitereEquals: function byRelevantFuerWeitereEquals(relevantfuerweitere, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byRelevantFuerWeitereEquals', 'relevantfuerweitere')(relevantfuerweitere, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    bySeiteEndeEquals: function bySeiteEndeEquals(seiteende, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySeiteEndeEquals', 'seiteende')(seiteende, additionalParams);
    },
    bySeiteEndeLike: function bySeiteEndeLike(seiteende, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySeiteEndeLike', 'seiteende')(seiteende, additionalParams);
    },
    bySeiteStartEquals: function bySeiteStartEquals(seitestart, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySeiteStartEquals', 'seitestart')(seitestart, additionalParams);
    },
    bySeiteStartLike: function bySeiteStartLike(seitestart, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySeiteStartLike', 'seitestart')(seitestart, additionalParams);
    },
    bySerientitelEquals: function bySerientitelEquals(serientitel, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySerientitelEquals', 'serientitel')(serientitel, additionalParams);
    },
    bySerientitelLike: function bySerientitelLike(serientitel, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySerientitelLike', 'serientitel')(serientitel, additionalParams);
    },
    bySpracheEquals: function bySpracheEquals(sprache, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySpracheEquals', 'sprache')(sprache, additionalParams);
    },
    bySpracheLike: function bySpracheLike(sprache, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'bySpracheLike', 'sprache')(sprache, additionalParams);
    },
    byTitelPublikationEquals: function byTitelPublikationEquals(titelpublikation, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byTitelPublikationEquals', 'titelpublikation')(titelpublikation, additionalParams);
    },
    byTitelPublikationLike: function byTitelPublikationLike(titelpublikation, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byTitelPublikationLike', 'titelpublikation')(titelpublikation, additionalParams);
    },
    byValidiertEquals: function byValidiertEquals(validiert, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byValidiertEquals', 'validiert')(validiert, additionalParams);
    },
    byVerlagsortEquals: function byVerlagsortEquals(verlagsort, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byVerlagsortEquals', 'verlagsort')(verlagsort, additionalParams);
    },
    byVerlagsortLike: function byVerlagsortLike(verlagsort, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byVerlagsortLike', 'verlagsort')(verlagsort, additionalParams);
    },
    byVerlegerEquals: function byVerlegerEquals(verleger, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byVerlegerEquals', 'verleger')(verleger, additionalParams);
    },
    byVerlegerLike: function byVerlegerLike(verleger, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byVerlegerLike', 'verleger')(verleger, additionalParams);
    },
    byVeroeffentlichungsJahrEquals: function byVeroeffentlichungsJahrEquals(veroeffentlichungsjahr, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byVeroeffentlichungsJahrEquals', 'veroeffentlichungsjahr')(veroeffentlichungsjahr, additionalParams);
    },
    byWeitereOrganisationseinheitenEquals: function byWeitereOrganisationseinheitenEquals(weitereorganisationseinheiten, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'byWeitereOrganisationseinheitenEquals', 'weitereorganisationseinheiten')(weitereorganisationseinheiten, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'findAll', 'page')(page, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'findOne', 'projection')(projection, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    updatedAfter: function updatedAfter(timestamp, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'updatedAfter', 'timestamp')(timestamp, additionalParams);
    },
    withoutPubmanID: function withoutPubmanID(page, additionalParams) {
      return templates.searchTemplate(connection)(Publikation, 'withoutPubmanID', 'page')(page, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Publikation, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('publikation')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/publikation.js
// module id = O6Vv
// module chunks = 0